<template>
  <div :class="[ bgGreenCheck ? 'bg-green-400': 'bg-blue-150',]">
    <div class='relative overflow-hidden' :style='boxStyle'>
      <div class='container'>
        <div class='flex pt-50 pb-50 pr-50 mb-pa-0' ref='heightLeftColum' >
          <div class='w-335 mb-wp-100'>
            <h2 class='fs-36 mb-fs-28 fw-900 mb-30'>
              <slot name="title"></slot>
            </h2>
            <p class='mb-0'>
              <slot name="sub-title"></slot>
            </p>
          </div>
        </div>
      </div>
      <div class='flex mb-relative absolute top-0 mb-top-0 mb-mt-30 slide' ref='infoBox'>
        <ClientOnly>
        <transition>
          <Carousel
            :wrap-around="true"
            :itemsToShow= itemsToShow
            :autoplay='100000'
            class='inner-wrapper'
          >
            <template #counter>
            </template>
            <Slide
              class='carousel__item'
              v-for="(item,index) in listReviews" :key="index"
            >
              <div class='item tl relative w-300 mb-wp-100 pa-30 bg-white br-14'>
                <div class='absolute w-50 h-50 ntop-25 nleft-25 bd-2 bd-white br-p-50'>
                  <img v-if='item.avatar.length' :src="item.avatar" alt='' class='img-cover filter br-p-50'>
                  <div v-else class='no-img wp-100 hp-100 br-p-50'></div>
                </div>
                <div>
                  <p class='mb-10 fs-14 lh-18 fw-700' v-html='item.content'></p>
                </div>
                <p class='tr mb-0 author'>
                  <span class='fs-12 fw-700 lh-18 gray-dark'>{{item.author}}</span>
                </p>
              </div>
            </Slide>

            <template #addons>
              <Navigation class='next-prev-button' >
                  <template #prev>
                    <div class="hand"><img alt='prev' src="https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-left-large.svg"  /></div>
                  </template>
                  <template #next>
                    <div class="hand"><img alt='next' src="https://s3-cdn.designerjourneys.com/static/icons/icon-arrow-right-large.svg"  /></div>
                  </template>
              </Navigation>
            </template>
          </Carousel>
        </transition>
        <template #fallback>
          <div class="carousel__item" v-for="(item, index) in listReviews" :key="index">
            <div class="item tl relative w-300 mb-wp-100 pa-30 bg-white br-14">
              <div class="absolute w-50 h-50 ntop-25 nleft-25 bd-2 bd-white br-p-50">
                <img v-if="item.avatar.length" :src="item.avatar" alt="" class="img-cover filter br-p-50" />
                <div v-else class="no-img wp-100 hp-100 br-p-50"></div>
              </div>
              <div>
                <p class="mb-10 fs-14 lh-18 fw-700" v-html="item.content"></p>
              </div>
              <p class="tr mb-0 author">
                <span class="fs-12 fw-700 lh-18 gray-dark">{{ item.author }}</span>
              </p>
            </div>
          </div>
        </template>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>
<script>
import Slide from '~/components/ui/carousel/Slide'
import Carousel from '~/components/ui/carousel/Carousel'
import Navigation from '~/components/ui/carousel/Navigation'
import { PHONE, TABLET } from '~/constant/common'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
export default {
  components: {
    Slide,
    Carousel,
    Navigation
  },
  props: {
    listReviews: {
      type: Array,
      default: null
    },
  },
  setup() {
    const infoBox = ref(0);
    const boxStyle = ref({});
    const route = useRoute();
    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(() => generalStore.generalData.windowWidth);
    const matchHeight = () => {
      if(windowWidth.value > PHONE) {
        boxStyle.value = {minHeight: infoBox.value.clientHeight + 'px'}
      }
    }

    const bgGreenCheck = computed(()=> {
      const bgGreen = ['become-local-designer', 'signup-agent'];

      return bgGreen.includes(route.name);
    })

    onMounted(() => {
      matchHeight()
    })


    const itemsToShow = computed(() => {
      if(
        windowWidth.value < TABLET) {
        return 1
      }
      return 3
    });

    return {itemsToShow,PHONE, TABLET, matchHeight, infoBox, boxStyle, bgGreenCheck}
  }
}
</script>
<style scoped lang='scss'>
.no-img {
  background: #ccc;
}
.filter {
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.15));
}
.author span {
  position: relative;
  &:before {
    content: '';
    background-color: #d0d0d0;
    position: absolute;
    top: calc(50% - 2px);
    right: calc(100% + 9px);
    width: 15px;
    height: 2px;
    border-radius: 8px;
  }
}

.carousel__item {
  padding: 50px 45px;
  display: block;
}
.carousel__slide {
  opacity: 1;
}
.slide {
  left: calc(50% - 225px);
  max-width: 1065px;
  @media (max-width: 1300px) {
    left: calc(50% - 200px);
  }
  @media (max-width: 1199px) {
    left: 405px;
  }
  @include phone {
    left: 0;
  }
  .inner-wrapper {
    width: 100%;
    .next-prev-button {
      position: absolute;
      left: -335px;
      text-align: left;
      top: 286px;
      @include phone {
        top:0;
        left: 20px;
      }
    }

  }
    :deep(.carousel) {
        .item {
            box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
        }
        .carousel__slide--prev .item {
            box-shadow: none;
        }
        .carousel__prev, .carousel__next {
            position: relative;
            left: auto;
            top: auto;
            bottom: auto;
            right: auto;
            display: inline-block;
            margin-right: 30px;
        }
    }
}
</style>
